import React, { useState } from 'react';
import { useCustomerShips } from '../hooks/useCustomerShip';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Container, Box, Pagination, Alert, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function CustomerShip() {
  const { customerShips, page, totalPages, setPage, setSearchQuery, error } = useCustomerShips();
  const [searchText, setSearchText] = useState<string>('');

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearch = () => {
    setSearchQuery(searchText);
    setPage(1);
  };

  return (
    <Container>
      <h2>顧客配送先管理</h2>
      <Box display="flex" justifyContent="space-between" mb={5}>
        <TextField
          variant="outlined"
          placeholder="顧客名で検索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleSearch}>
                  <SearchIcon />
                </Button>
              </InputAdornment>
            ),
          }}
          sx={{ maxHeight: 10 }}
        />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>顧客配送先コード</TableCell>
            <TableCell>顧客コード<br />顧客名</TableCell>
            <TableCell>配送先コード<br />配送先名</TableCell>
            <TableCell>住所</TableCell>
            <TableCell>電話番号<br />FAX</TableCell>
            <TableCell>メールアドレス</TableCell>
            <TableCell>最終更新日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customerShips.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.id}</TableCell>
              <TableCell>{item.customer_id}<br />{item.customer_name}</TableCell>
              <TableCell>{item.ship_id}<br/>{item.ship_name}</TableCell>
              <TableCell>
                📮{item.ship_postal_code}
                <br />
                {item.ship_address1}
                <br />
                {item.ship_address2 === "Empty" ? "" : item.ship_address2}
              </TableCell>
              <TableCell>{item.ship_tel}<br />{item.ship_fax}</TableCell>
              <TableCell>{item.ship_email}</TableCell>
              <TableCell>{item.updated_at?.replace('T', ' ').split('+')[0]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
      </Box>
    </Container>
  );
}
